export default __webpack_public_path__ + "static/media/144.77e77b0e.png";